import type React from 'react';
import { CheckCircleIcon } from '@phosphor-icons/react';

interface LoadingCompleteIndicatorProps {
  isLoading: boolean;
  isCompleted?: boolean;
  size?: number | string;
  color?: string;
}

const LoadingCompleteIndicator: React.FC<LoadingCompleteIndicatorProps> = ({ isLoading, isCompleted, size = 20, color = 'inherit' }) => {
  return (
    <div className="flex items-center justify-center">
      {isLoading && (
        <div
          className="animate-spin rounded-full border-2 border-current border-t-transparent"
          style={{ width: size, height: size }}
        />
      )}
      {isCompleted && (
        <CheckCircleIcon size={20} color="green" weight="fill" />
      )}
    </div>
  );
};

export default LoadingCompleteIndicator;
